import {
  Accordion,
  AccordionSummary,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import { RegistrationType } from "../../Base/AdoptionConstants";
import { makeStyles } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  responsiveDialog: {
    [theme.breakpoints.down("xs")]: {
      margin: 0,
      maxWidth: "100%",
      width: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
    },
  },
  compactTitle: {
    [theme.breakpoints.down("sm")]: {
      padding: "0.25rem 0.5rem",
    },
  },
  compactActions: {
    [theme.breakpoints.down("sm")]: {
      padding: "0.25rem 0.5rem",
    },
  },
  compactContent: {
    [theme.breakpoints.down("sm")]: {
      padding: "0.25rem 0.5rem",
    },
  },
}));

export default function NewRegistrationDialog({ open, onClose, includeAdultAdoptee, isPaperRegistration, ...props }) {
  const [clickedSubmit, setClickedSubmit] = React.useState(false);
  const [registrationType, setRegistrationType] = React.useState("");
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={() => {
        setRegistrationType("");
        setClickedSubmit(false);
        onClose();
      }}
      aria-labelledby="new-registration-dialog-title"
      aria-describedby="new-registration-dialog-description"
      classes={{ paper: classes.responsiveDialog }}
      {...props}
    >
      <DialogTitle id="new-registration-dialog-title" className={classes.compactTitle}>
        <span style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Who are you registering {isPaperRegistration ? "for" : "as"}? </span>
          <IconButton size="small" color="default" onClick={onClose} aria-label="close-dialog">
            <Close />
          </IconButton>
        </span>
      </DialogTitle>
      <DialogContent id="new-registration-dialog-description" className={classes.compactContent}>
        <FormControl component="fieldset" style={{ width: "100%" }} error={clickedSubmit && !registrationType}>
          <FormLabel component="legend">Please choose one:</FormLabel>
          <RadioGroup
            name="registrationType"
            style={{ marginTop: 12 }}
            value={registrationType}
            onChange={(e) => setRegistrationType(e.target.value)}
          >
            <Accordion expanded={registrationType === RegistrationType.BIRTH_PARENT.value} style={{ width: "100%" }}>
              <AccordionSummary
                expandIcon={null}
                aria-label="Select and Expand"
                aria-controls="birth-parent-selection"
                id="birth-parent-selection"
                onClick={() => setRegistrationType(RegistrationType.BIRTH_PARENT.value)}
              >
                <FormControlLabel
                  value={RegistrationType.BIRTH_PARENT.value}
                  control={<Radio id="birth-parent-selection-radio" inputProps={{ tabIndex: -1 }} />}
                  label={RegistrationType.BIRTH_PARENT.label}
                />
              </AccordionSummary>
            </Accordion>
            {includeAdultAdoptee && (
              <Accordion expanded={registrationType === RegistrationType.ADOPTEE.value} style={{ width: "100%" }}>
                <AccordionSummary
                  expandIcon={null}
                  aria-label="Select and Expand"
                  aria-controls="adoptee-selection"
                  id="adoptee-selection"
                  onClick={() => setRegistrationType(RegistrationType.ADOPTEE.value)}
                >
                  <FormControlLabel
                    value={RegistrationType.ADOPTEE.value}
                    control={<Radio id="adoptee-selection-radio" inputProps={{ tabIndex: -1 }} />}
                    label={RegistrationType.ADOPTEE.label}
                  />
                </AccordionSummary>
              </Accordion>
            )}

            <Accordion expanded={registrationType === RegistrationType.SIBLING.value} style={{ width: "100%" }}>
              <AccordionSummary
                expandIcon={null}
                aria-label="Select and Expand"
                aria-controls="sibling-selection"
                id="sibling-selection"
                onClick={() => setRegistrationType(RegistrationType.SIBLING.value)}
              >
                <FormControlLabel
                  value={RegistrationType.SIBLING.value}
                  control={<Radio id="sibling-selection-radio" inputProps={{ tabIndex: -1 }} />}
                  label={RegistrationType.SIBLING.label}
                />
              </AccordionSummary>
            </Accordion>
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions className={classes.compactActions}>
        <Button
          color="primary"
          variant="contained"
          //   className={classes.AdoptionRegistrationButton}
          size="large"
          component={Link}
          to={{ pathname: "/registration", state: { registrationType, isPaperRegistration } }}
          onClick={(e) => {
            setClickedSubmit(true);
            if (!registrationType) {
              e.preventDefault();
            }
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
